import React, { Component } from "react";
import Modal from '../../components/layouts/Modal';

// answers a yes or no question
// replaces Confirmation component

class Prompt extends Component {
  render() {
    return (
      <Modal open={this.props.open}>
        <section className="cardSection _withColumns">
          <div className="text">
            <p className="copy">{this.props.copy}</p>
          </div>
          <div className="ds-buttonGroup _spacedButtons">
            <button onClick={this.props.onConfirm} className="ds-btn">Yes</button>
            <button onClick={this.props.onCancel} className="ds-btn -danger">No</button>
          </div>
        </section>
      </Modal>
    )
  }
}

export default Prompt;



// WEBPACK FOOTER //
// ./src/features/shared/components/notices/Prompt.js